export const GET_HEADER_WORKFLOW = 'GET_HEADER_WORKFLOW';
export const GET_HEADER_WORKFLOW_START = `${GET_HEADER_WORKFLOW}_START`;
export const GET_HEADER_WORKFLOW_SUCCESS = `${GET_HEADER_WORKFLOW}_SUCCESS`;
export const GET_HEADER_WORKFLOW_FAIL = `${GET_HEADER_WORKFLOW}_FAIL`;

export const UPDATE_HEADER_WORKFLOW = 'UPDATE_HEADER_WORKFLOW';
export const UPDATE_HEADER_WORKFLOW_START = `${UPDATE_HEADER_WORKFLOW}_START`;
export const UPDATE_HEADER_WORKFLOW_SUCCESS = `${UPDATE_HEADER_WORKFLOW}_SUCCESS`;
export const UPDATE_HEADER_WORKFLOW_FAIL = `${UPDATE_HEADER_WORKFLOW}_FAIL`;

export const SET_HEADER_WORKFLOW = 'SET_HEADER_WORKFLOW';
export const CLEAR_HEADER_WORKFLOW = 'CLEAR_HEADER_WORKFLOW';
export const PRELOAD_HEADER_WORKFLOW = 'PRELOAD_HEADER_WORKFLOW';

// used by GWT
export const SET_HEADER_WORKLFOW_ID = 'SET_HEADER_WORKLFOW_ID';

export function getWorkflow(id) {
  return {
    type: GET_HEADER_WORKFLOW,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${id}`,
      method: 'get',
      params: {
        embed: 'permitted',
      },
    },
  };
}

export function updateWorkflow(id, updatedFields) {
  return {
    type: UPDATE_HEADER_WORKFLOW,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/plans',
      method: 'post',
      params: {
        id,
        ...updatedFields,
      },
    },
  };
}

export function setHeaderWorkflowId(workflowId) {
  return {
    type: SET_HEADER_WORKLFOW_ID,
    payload: workflowId,
  };
}

export function clearHeaderWorkflow() {
  return {
    type: CLEAR_HEADER_WORKFLOW,
  };
}
